import React from "react";
import { Link } from "react-router-dom";
import { AiOutlineHeart, AiFillHeart } from "react-icons/ai";
import Moment from "react-moment";
import { auth } from "../firebaseConfig";
import useSnapshot from "../utils/useSnapshot";
import { toggleFavorite } from "../utils/fav";
import Pending from "../components/Pending";

const AdCard = ({ ad, hideImage = false }) => {
  const { val } = useSnapshot("favorites", ad.adId);

  // Construct a link for this ad based on its category and ID
  const adLink = `/${ad.category.toLowerCase()}/${ad.adId}`;

  return (
    <div className="card position-relative">
      {/* Show a "Pending" overlay if the ad is marked as pending */}
      {ad.isPending && <Pending />}

      {/* Render the image only if hideImage is false */}
      {!hideImage && (
        <Link to={adLink}>
          <img
            src={ad.images[0].url}
            alt={ad.title}
            className="card-img-top"
            style={{
              width: "100%",      // занимает всю ширину карточки
              maxHeight: "300px", // ограничиваем высоту 300px
              objectFit: "contain", // "contain" покажет картинку целиком
            }}
          />
        </Link>
      )}

      <div className="card-body">
        {/* Only show favorite icons if there is a logged-in user */}
        {auth.currentUser ? (
          <p className="d-flex justify-content-between align-items-center">
            <small>{ad.category}</small>
            {val?.users?.includes(auth.currentUser?.uid) ? (
              <AiFillHeart
                size={30}
                onClick={() => toggleFavorite(val.users, ad.adId)}
                className="text-danger"
              />
            ) : (
              <AiOutlineHeart
                size={30}
                onClick={() => toggleFavorite(val.users, ad.adId)}
                className="text-danger"
              />
            )}
          </p>
        ) : (
          // If the user is not logged in, simply show the category without the icons
          <p className="d-flex justify-content-between align-items-center">
            <small>{ad.category}</small>
          </p>
        )}

        {/* Title of the ad */}
        <Link to={adLink}>
          <h5 className="card-title">{ad.title}</h5>
        </Link>

        {/* Location, time since published, gender, and event date */}
        <Link to={adLink}>
          <p className="card-text">
            {/* Display gender if available */}
            {ad.gender && (
              <span>
                For: {ad.gender}
                <br />
              </span>
            )}

            {/* Display location if available */}
            {ad.location && (
              <span>
                Location: {ad.location}
                <br />
              </span>
            )}

            {/* Display eventDate if available */}
            {ad.eventDate && (
              <span>
                Event Date:{" "}
                <Moment format="DD MMM YYYY">{ad.eventDate.toDate()}</Moment>
                <br />
              </span>
            )}

            {/* Display time since published */}
            Posted: <Moment fromNow>{ad.publishedAt.toDate()}</Moment>
          </p>
        </Link>
      </div>
    </div>
  );
};

export default AdCard;
